import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PhoneOutgoing, Check } from "lucide-react";
import api from "@/lib/api";
import { dialNumber } from "@/lib/phone";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function MyCalls() {
  const [rows, setRows] = useState([]);
  const [notes, setNotes] = useState({});
  const navigate = useNavigate();

  const load = () => api.get("/call-tasks").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const complete = async (t) => {
    try {
      await api.put(`/call-tasks/${t.id}`, { status: "Done", note: notes[t.id] || "" });
      toast.success("Marked done"); load();
    } catch (e) { toast.error("Could not update — try again"); }
  };

  const pending = rows.filter((r) => r.status !== "Done");
  const done = rows.filter((r) => r.status === "Done");

  return (
    <div className="space-y-6">
      <div><h1 className="text-3xl font-heading font-bold tracking-tight flex items-center gap-2"><PhoneOutgoing size={24} className="text-primary" /> My Outbound Calls</h1><p className="text-muted-foreground mt-1">Renewal & follow-up calls assigned to you — {pending.length} pending.</p></div>

      <div className="rounded-sm border border-border bg-card overflow-hidden">
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>Customer</TableHead><TableHead>Phone</TableHead><TableHead>Reason</TableHead><TableHead>Outcome note</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody data-testid="my-calls-body">
            {pending.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">No pending calls. 🎉</TableCell></TableRow>}
            {pending.map((t) => (
              <TableRow key={t.id} data-testid={`call-row-${t.id}`}>
                <TableCell className="font-medium cursor-pointer hover:text-primary" onClick={() => navigate(`/clients/${t.customer_id}`)}>{t.customer_name}</TableCell>
                <TableCell className="font-mono text-sm"><button onClick={() => dialNumber(t.phone)} className="flex items-center gap-1.5 text-primary hover:opacity-80" data-testid={`call-dial-${t.id}`}><PhoneOutgoing size={14} /> {t.phone || "—"}</button></TableCell>
                <TableCell><Badge variant="outline" className="rounded-sm">{t.reason}</Badge></TableCell>
                <TableCell><Input value={notes[t.id] || ""} onChange={(e) => setNotes({ ...notes, [t.id]: e.target.value })} placeholder="What happened…" className="rounded-sm h-8" data-testid={`call-note-${t.id}`} /></TableCell>
                <TableCell className="text-right"><Button size="sm" className="rounded-sm gap-1.5" onClick={() => complete(t)} data-testid={`call-done-${t.id}`}><Check size={14} /> Done</Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {done.length > 0 && (
        <div>
          <h3 className="font-heading font-semibold mb-2 text-muted-foreground">Completed ({done.length})</h3>
          <div className="rounded-sm border border-border bg-card divide-y divide-border">
            {done.map((t) => (<div key={t.id} className="flex items-center gap-3 px-4 py-2.5 text-sm"><span className="font-medium">{t.customer_name}</span><span className="text-muted-foreground">{t.note}</span><Badge variant="outline" className="rounded-sm ml-auto bg-success/15 text-success border-success/30">Done</Badge></div>))}
          </div>
        </div>
      )}
    </div>
  );
}
